import { render, staticRenderFns } from "./AllReceivablesDownloadAssignmentDocumentsModal.vue?vue&type=template&id=a885f3a2&"
import script from "./AllReceivablesDownloadAssignmentDocumentsModal.vue?vue&type=script&lang=js&"
export * from "./AllReceivablesDownloadAssignmentDocumentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports